import { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
//import { MdTranslate } from "react-icons/md";
import IconNav from "../../components/nav-bar/icon-nav";
import "./g-translate.scss";

const GTranslate = ({ iconMenu }) => {
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (!window.gtranslateSettings) {
            window.gtranslateSettings = {
                default_language: "en",
                detect_browser_language: true,
                //  languages: ["en", "es"],
                wrapper_selector: ".gtranslate_wrapper"
            };

            const script = document.createElement("script");
            script.src = "https://cdn.gtranslate.net/widgets/latest/dropdown.js";
            script.defer = true;
            document.body.appendChild(script);

            //Spanish url default automatically transalte to spanish
            const spanishUrls = (process.env.REACT_APP_SPANISH_URLS || "").split(",");
            if (spanishUrls.length > 0 && spanishUrls[0] !== "") {
                if (spanishUrls.some(url => window.location.href.includes(url))) {
                    document.cookie = "googtrans=/en/es; path=/";
                }
            }


            return () => {
                document.body.removeChild(script);
                delete window.gtranslateSettings;
            };
        }
    }, []);

    const toggleDropdown = () => {
        setDropdownVisible(!isDropdownVisible);
    };

    const handleClickOutside = useCallback(event => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownVisible(false);
        }
    }, []);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleClickOutside]);

    return (
        <div style={{ position: "relative" }} className="d-flex d-md-block" ref={dropdownRef}>
            {/* Icon to toggle the dropdown */}

            {iconMenu &&
                <IconNav
                    //label="Translate"
                    label={iconMenu.subheader}
                    handleClick={toggleDropdown}>
                    {/*<MdTranslate />*/}
                    {iconMenu.icon}
                </IconNav>
            }

            {/* Dropdown wrapper */}
            <div
                id=".gtranslate_wrapper_element"
                className={`gtranslate_wrapper ${isDropdownVisible ? "visible" : "invisible"}`}></div>
        </div>
    );
};

export { GTranslate };
GTranslate.propTypes = {
    iconMenu: PropTypes.object.isRequired,
};
